/** Pre-fills the affiliate chat composer. Read by AffiliateChatPage; never auto-sent. */
export const AFFILIATE_AI_PROMPT_QUERY_PARAM = 'prompt';

/** What the Templates page hands the chat. The chat's own instructions turn it into a
 * create_template_from_document call once the user attaches the document. */
export const AFFILIATE_TEMPLATE_PROMPT =
  'Generate a template from the attached document';

/** Firm scope spans the member's reachable clients; client scope is pinned to one of them. */
export type TAffiliateAiScope = 'firm' | 'client';

/** Links from other affiliate surfaces into the chat with the composer already filled in. */
export class AffiliateAiPromptHelper {
  static readonly CLIENT_QUERY_PARAM = 'client';

  /** Starter prompts on the blank chat (Figma: Affiliate App / Chat, node 93:18561). Each sends its
   * text as the first message through the same create-on-send flow as the composer. */
  static readonly SUGGESTED_PROMPTS = [
    'Which entities need a local file this year?',
    'When is the next master file deadline?',
    'Which policies have no benchmark study attached?',
    'Draft an intercompany services agreement',
  ];

  /** `?client=all` names firm scope explicitly; a missing param means the same. */
  static readonly ALL_CLIENTS_PARAM_VALUE = 'all';

  static readonly ALL_CLIENTS_LABEL = 'All clients';

  static buildChatHref(
    affiliateFirmId: string,
    prompt: string,
    clientId?: string
  ): string {
    const query = new URLSearchParams();
    // The client is kept so the chat opens on the workspace the user was already looking at,
    // rather than sending them back through the client picker.
    if (clientId)
      query.set(AffiliateAiPromptHelper.CLIENT_QUERY_PARAM, clientId);
    query.set(AFFILIATE_AI_PROMPT_QUERY_PARAM, prompt);

    return `/affiliate/${affiliateFirmId}/commenda-ai?${query.toString()}`;
  }
}
